import Component from "@glimmer/component"

interface Signature {
  Args: {
    groupState: "open" | "closed" | "locked"
  }
}

export default class SchoolEditPaymentNoticeBar extends Component<Signature> {}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "School::Edit::Payment::NoticeBar": typeof SchoolEditPaymentNoticeBar
  }
}
